// eslint-disable-next-line import/prefer-default-export
export const analyticsEvents = {
  socialSharingSettingChanged: 'edx.social.video_sharing_setting.changed',
};
